// Translations for the member's own Profile page (Profile.js): photo
// banner, document upload, membership history, personal/employment/contact
// info tabs (view + edit mode). Source text here is mostly Swahili-first;
// t() works the same regardless of which language the string is written in.
const profileDict = [
  { en: "My Profile", sw: "Wasifu Wangu" },
  { en: "View and edit your personal information", sw: "Angalia na hariri taarifa zako za kibinafsi" },
  { en: "Loading...", sw: "Inapakia..." },
  { en: "Loading details...", sw: "Inapakia taarifa..." },
  { en: "Uploading photo...", sw: "Inapakia picha..." },
  { en: "Member", sw: "Mwanachama" },
  { en: "Number:", sw: "Namba:" },
  { en: "Change Photo", sw: "Badilisha Picha" },
  { en: "Upload Photo", sw: "Weka Picha" },
  { en: "Choose a clear photo of your face (JPG, PNG, or GIF, up to 5MB)", sw: "Chagua picha nzuri ya uso wako (JPG, PNG, au GIF, hadi 5MB)" },
  { en: "Event", sw: "Tukio" },
  { en: "Profile created via bulk import", sw: "Wasifu uliundwa kwa uingizaji wa pamoja (bulk import)" },
  { en: "Show less", sw: "Onyesha kidogo" },
  { en: "Show all", sw: "Onyesha yote" },
  { en: "Photo", sw: "Picha" },
  { en: "Membership Documents", sw: "Nyaraka za Uanachama" },
  { en: "Document type", sw: "Aina ya hati" },
  { en: "Identity", sw: "Kitambulisho" },
  { en: "Proof of Employment", sw: "Uthibitisho wa Ajira" },
  { en: "Other", sw: "Nyingine" },
  { en: "Document name", sw: "Jina la hati" },
  { en: "File (PDF/Word)", sw: "Faili (PDF/Word)" },
  { en: "Upload Document", sw: "Pakia Hati" },
  { en: "No documents uploaded.", sw: "Hakuna nyaraka zilizopakiwa." },
  { en: "Status", sw: "Hali" },
  { en: "Membership History", sw: "Historia ya Uanachama" },
  { en: "Date", sw: "Tarehe" },
  { en: "Personal Information", sw: "Taarifa ya Kibinafsi" },
  { en: "Edit", sw: "Hariri" },
  { en: "Employment Information", sw: "Taarifa za Ajira" },
  { en: "Contact Information", sw: "Taarifa za Mawasiliano" },
  { en: "First Name", sw: "Jina la Kwanza" },
  { en: "Middle Name", sw: "Jina la Kati" },
  { en: "Gender", sw: "Jinsia" },
  { en: "Select gender", sw: "Chagua jinsia" },
  { en: "Male", sw: "Mwanaume" },
  { en: "Female", sw: "Mwanamke" },
  { en: "Date of Birth", sw: "Tarehe ya Kuzaliwa" },
  { en: "National ID (NIDA/NIN)", sw: "NIDA/NIN" },
  { en: "Last Name", sw: "Jina la Mwisho" },
  { en: "Email", sw: "Barua pepe" },
  { en: "Employment Number", sw: "Namba ya Ajira" },
  { en: "Employer", sw: "Mwajiri" },
  { en: "Job Title", sw: "Cheo cha Kazi" },
  { en: "Department", sw: "Idara" },
  { en: "Phone", sw: "Simu" },
  { en: "Address", sw: "Anwani" },
  { en: "Emergency Contact Name", sw: "Jina la Dharura" },
  { en: "Emergency Contact Phone", sw: "Simu ya Dharura" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Save", sw: "Hifadhi" },
  { en: "Full Name", sw: "Jina Kamili" },
  { en: "Member Number", sw: "Namba ya Mwanachama" },
  { en: "Enrollment Date", sw: "Tarehe ya Ujumbe" },
  { en: "Enrollment Status", sw: "Hali ya Ujumbe" },
  { en: "Salary Range", sw: "Pembezo la Mshahara" },
  { en: "Failed to load profile", sw: "Hitilafu imetokea kupakia profile" },
  { en: "Please choose a valid image (JPG, PNG, etc.)", sw: "Tafadhali chagua picha sahihi (JPG, PNG, etc.)" },
  { en: "Photo is too large. Maximum size is 5MB", sw: "Picha ni kubwa sana. Ukubwa wa juu ni 5MB" },
  { en: "Photo updated!", sw: "Picha imebadilishwa!" },
  { en: "An error occurred while uploading the photo", sw: "Hitilafu imetokea kupakia picha" },
  { en: "Please fill in all required fields", sw: "Tafadhali jaza vipu vyote vya lazima" },
  { en: "Please enter a valid email (e.g. example@domain.com)", sw: "Tafadhali ingiza email sahihi (mfano: example@domain.com)" },
  { en: "Details updated!", sw: "Taarifa zimebadilishwa!" },
  { en: "An error occurred while updating the details", sw: "Hitilafu imetokea kubadilisha taarifa" },
  { en: "Document uploaded.", sw: "Hati imepakiwa." },
  { en: "Failed to upload document", sw: "Imeshindikana kupakia hati" },
];

export default profileDict;
